import httpClient from "@/api/httpClient";
import { LoginRequest, LoginResponse } from "./auth.interfaces";

export const login = async (payload: LoginRequest): Promise<LoginResponse> => {
  const response = await httpClient.post("/v1/user/sign-in", payload);
  return response.data;
};
